import {observable, computed} from 'mobx';

class Security {
  @observable passwordRequires = [];

  @observable passwordMinLength;

  @observable passwordTryTimes;

  @observable passwordDuplication;

  @observable allowMultiSession;

  @observable sessionTimeOut;

  @observable ipWhiteList = [];

  @observable ipBlackList = [];

  @observable mfaType = '';

  // 判断是否是白名单，若黑白名单均为空，默认显示白名单
  @computed get isShowWhiteList() {
    return (this.ipBlackList || []).length === 0;
  }

  updateFromJson(json) {
    this.passwordMinLength = json.passwordMinLength;
    this.passwordTryTimes = json.passwordTryTimes;
    this.passwordRequires = json.passwordRequires;
    this.passwordDuplication = json.passwordDuplication;
    this.allowMultiSession = json.allowMultiSession;
    this.sessionTimeOut = json.sessionTimeOut;
    this.ipWhiteList = json.ipWhiteList;
    this.ipBlackList = json.ipBlackList;
    this.mfaType = json.mfaType;
  }
}

export default Security;
